import React, { useEffect, useState } from 'react'
import { MdPerson2 } from 'react-icons/md'
import adminServices from '../../services/AdminServices'

function PatientStats() {
    const [statistics, setStatics] = useState()
    useEffect(() => {
        adminServices.patientStats().then(
            res => {
                setStatics(res.data)
            },
            err => {
                console.log(err);
                
            }
        )
    }, [])
    useEffect(() => {}, [statistics])
    return (
        <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Total Patients</p>
                            <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{statistics?.patient_count}</p>
                        </div>
                        <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3 ">
                            <span className="material-symbols-outlined"><MdPerson2 className='h-6 w-6' /></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PatientStats